import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Attribute selection
 *
 * Attributes differ from addons in that attributes map to a product
 * "variation", effectively changing the product that is selected
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Minifigs
 */
const Attributes = ({ attributes, variations, activeSection, skintone, selected, onChange, optionLabel }) => {
    let selectedAttr;
    let variationsVariantsArr = variations;

    if (typeof variationsVariantsArr === 'undefined') {
        return (
            <div className="attributes">
                <p>There are no attributes</p>
            </div>
        );
    } else if (variationsVariantsArr.length === 1) {
        selectedAttr = variationsVariantsArr[0].id?.split('/').pop();
        return (
            <div className="attributes">
                <input name="id" value={variationsVariantsArr[0]?.id?.split('/').pop()} type="hidden" />
            </div>
        );
    } else {
        return (
            <div className="attributes">
                <div className="product-variation">
                    <label>Choose a {optionLabel ? optionLabel : 'colour'}</label>
                    <div className="product-variation-input">
                        <select
                            name="id"
                            defaultValue={selected}
                            onChange={(e) => {
                                {
                                    variationsVariantsArr.map((attr) => {
                                        let theAttribute = attr;
                                        if (!attr.id) {
                                            theAttribute = attr.node;
                                        }

                                        const variantId = theAttribute.id.split('/').pop();
                                        if (variantId == e.target.value) {
                                            selectedAttr = theAttribute;
                                            onChange(selectedAttr, e.target.value);
                                        }
                                    });
                                }
                            }}
                        >
                            <option value="" disabled>
                                Choose an option
                            </option>
                            {variationsVariantsArr.map((attr) => {
                                let theAttribute = attr;
                                if (!attr.id) {
                                    theAttribute = attr.node;
                                }
                                const prodIdParsed = theAttribute.id.split('/').pop();

                                return (
                                    <option
                                        value={prodIdParsed}
                                        key={prodIdParsed}
                                        disabled={
                                            activeSection === 'heads' &&
                                            !theAttribute?.title?.toLowerCase().includes(skintone.toLowerCase())
                                        }
                                    >
                                        {theAttribute.title} (£{theAttribute.priceV2.amount})
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <span className="please-choose-warning">Please choose a product variant to continue.</span>
                </div>
            </div>
        );
    }
};

/**
 * Get the value (slug) of an attribute term
 *
 * @param {number} attributeId The ID of the attribute we're getting terms for
 * @param {string} option The option name
 * @param {array} terms All attribute terms
 * @return {string}
 */
const getAttributeTerm = (attributeId, option, terms) => {
    // if the attribute ID is 0, this means it's a local attribute (not global)
    // and the value is just the option name
    if (attributeId === 0) {
        return option;
    }

    for (let i = 0; i < terms.length; i++) {
        const term = terms[i];
        if (term.name === option) {
            return term.slug;
        }
    }

    return '';
};

Attributes.propTypes = {
    attributes: PropTypes.array.isRequired,
    terms: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    variations: PropTypes.array,
    selected: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

Attributes.defaultProps = {
    attributes: [],
    terms: [],
    variations: {},
    selected: 0,
    onChange: () => {},
};

export default Attributes;
